var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.59C21 22.2476 21.6585 23.8373 22.8306 25.0094C24.0027 26.1815 25.5924 26.84 27.25 26.84H27.3C28.5234 26.8868 29.4875 26.6118 30.6187 25.8853C30.902 25.7051 31.2285 25.6043 31.5641 25.5934C31.8997 25.5825 32.232 25.6619 32.5264 25.8233C32.8208 25.9847 33.0665 26.2222 33.2377 26.511C33.409 26.7998 33.4996 27.1292 33.5 27.465V33.09C33.5 33.753 33.2366 34.3889 32.7678 34.8577C32.2989 35.3266 31.663 35.59 31 35.59H8.5C7.83696 35.59 7.20107 35.3266 6.73223 34.8577C6.26339 34.3889 6 33.753 6 33.09V8.08997C6 7.42692 6.26339 6.79104 6.73223 6.3222C7.20107 5.85336 7.83696 5.58997 8.5 5.58997H31C31.663 5.58997 32.2989 5.85336 32.7678 6.3222C33.2366 6.79104 33.5 7.42692 33.5 8.08997V13.715C33.4998 14.0513 33.4092 14.3814 33.2376 14.6707C33.066 14.9599 32.8197 15.1977 32.5246 15.3591C32.2295 15.5204 31.8964 15.5995 31.5603 15.5879C31.2242 15.5762 30.8973 15.4744 30.6141 15.2931C29.665 14.7008 28.5751 14.3724 27.4568 14.342C26.3385 14.3116 25.2323 14.5802 24.2525 15.12C23.2727 15.6598 22.4546 16.4514 21.8829 17.413C21.3111 18.3745 21.0063 19.4713 21 20.59Z",
    fill: "#C7C644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsIcon);
export default __webpack_public_path__ + "static/media/projects-icon.00505b9fc4b52eb5cb684e8f9cea561c.svg";
export { ForwardRef as ReactComponent };